<template>
  <div>
    <boton-atras :nombre_ruta="'MenuArmonizacion'"/>
    <div class="container text-center mb-5">
        <h1 class="bold300 text-uppercase" style=" font-weight:500;">Resultados de las Evaluaciones</h1>
    </div>
    <nav>
      <div class="nav nav-movil nav-tabs" id="nav-tab" role="tablist">
          <a
              class="nav-link"
              @click="itemActive1 = true, itemActive2 = false, itemActive3 = false"
              :class="[
                (!modoDark_var && itemActive1 && !itemActive2)? 'active' : '',
                (modoDark_var && itemActive1 && !itemActive2)? 'DarkActive active' : '',
                (modoDark_var && itemActive1==false && (itemActive2))? 'darkInactivo' : ''
              ]"
              id="nav-normContable-tab"
              data-toggle="tab"
              href="#nav-normContable"
              role="tab"
              aria-controls="nav-normContable"
              aria-selected="true"
              > <span class="verPc"><p class="m-0">Armonización Contable</p></span><span class="verMovil"><p class="m-0">Contable</p></span>
          </a>
          <a
              class="nav-link"
              @click="itemActive1 = false, itemActive2 = true, itemActive3 = false"
              :class="[
                (!modoDark_var && itemActive2 && !itemActive1)? 'active' : '',
                (modoDark_var && itemActive2 && !itemActive1)? 'DarkActive active' : '',
                (modoDark_var && itemActive2==false && (itemActive1))? 'darkInactivo' : ''
              ]"
              id="nav-normFinanciera-tab"
              data-toggle="tab"
              href="#nav-normFinanciera"
              role="tab"
              aria-controls="nav-normFinanciera"
              aria-selected="false"
              >
              <span class="verPc"><p class="m-0">Resultados de las Evaluaciones</p></span><span class="verMovil"><p class="m-0">Resultados Evaluaciones</p></span>
          </a>
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div :class="[(itemActive1 && !itemActive2 && !itemActive3)? 'tab-pane fade show active' : 'tab-pane fade',]" id="nav-normContable" role="tabpanel" aria-labelledby="nav-normContable-tab">
          <div class="border"></div>
          <!-- componente aqui -->
          <tabla-simple class="mt-3" titulo="Armonización contable" :datos="resultadosEvaluacionesACList" />
          <span v-html="DateFormatText(fecha_actualizacion)"></span>
          <!-- <pre>{{ resultadosEvaluacionesACList }}</pre> -->
      </div>
      <div :class="[(itemActive2 && !itemActive1 && !itemActive3)? 'tab-pane fade show active' : 'tab-pane fade',]" id="nav-normFinanciera" role="tabpanel" aria-labelledby="nav-normFinanciera-tab">
        <!-- <div class="border"></div> -->
        <div class="card">
          <div class="card-body">
            <div class="row card-body">
              <div class="container text-left mb-3">
                  <h6>Resultados de las Evaluaciones</h6>
              </div>
              <px-select2
                idSelect="selecEvaluaciones"
                placeholder="Seleccione el año"
                :options="resultadosEvaluacionesList"
                @KuramaSelect="(selected = $event), (textoTitulo = selected.text)"
              ></px-select2>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end mt-5">
      </div>
        <!-- aqui puede estar tu componente, o tu info -->
        <div v-if="selected"> <!--<pre>{{ datos }}</pre>--->
          <div class="d-flex justify-content-between">
            <h5>{{ selected.text }}</h5>
          <!-- <search-vue class="w-10" :data="selected" @datos="datosRespuesta = $event" /> -->
          </div>
          <!-- <pre>{{ datosRespuesta }}</pre> -->
          <table class="styled-table">
            <tbody>
              <tr>
                <td>
                  <ul>
                    <li  v-for="(contenido, index) in selected.seccion" :key="index">
                      <div class="contenido-fila">
                        <!-- Mostrar título -->
                        <span class="contenido-titulo" :class="(contenido.url_pdf == '' && contenido.url_word == '' && contenido.url_excel == '' && contenido.url_comprimido == '')? 'strong' : ''">
                          {{ contenido.titulo }} <small class="text-muted">{{ contenido.pieTitulo }}</small>
                        </span>
                          <!-- Contenedor para los íconos -->
                          <div class="iconos-contenedor">
                            <a v-if="contenido.url_pdf" :href="urlServe + contenido.url_pdf" target="_blank">
                              <i class="fas fa-file-pdf icono-archivo icon-pdf"></i>
                            </a>
                            <a v-if="contenido.url_word" :href="urlServe + contenido.url_word" target="_blank">
                              <i class="fas fa-file-word icono-archivo icon-word"></i>
                            </a>
                            <a v-if="contenido.url_excel" :href="urlServe + contenido.url_excel" target="_blank">
                              <i class="fas fa-file-excel icono-archivo icon-excel"></i>
                            </a>
                            <a v-if="contenido.url_comprimido" :href="urlServe + contenido.url_comprimido" target="_blank">
                              <i class="fas fa-file-archive icono-archivo icon-rar"></i>
                            </a>
                          </div>
                      </div>
                      <div v-if="contenido.seccion.length>0">
                        <div v-for="(contenido, index) in contenido.seccion" :key="index">
                          <!-- <pre>{{ contenido.titulo }}</pre> -->
                          <div class="contenido-fila">
                            <!-- Mostrar título -->
                            <span class="contenido-titulo my-2 ml-4 border-bottom">{{ contenido.titulo || 'Descargar documento' }} <small class="text-muted">{{ contenido.pieTitulo }}</small> </span>

                            <!-- Contenedor para los íconos -->
                            <div class="iconos-contenedor">
                              <a v-if="contenido.url_pdf" :href="urlServe + contenido.url_pdf" target="_blank">
                                <i class="fas fa-file-pdf icono-archivo icon-pdf"></i>
                              </a>
                              <a v-if="contenido.url_word" :href="urlServe + contenido.url_word" target="_blank">
                                <i class="fas fa-file-word icono-archivo icon-word"></i>
                              </a>
                              <a v-if="contenido.url_excel" :href="urlServe + contenido.url_excel" target="_blank">
                                <i class="fas fa-file-excel icono-archivo icon-excel"></i>
                              </a>
                              <a v-if="contenido.url_comprimido" :href="urlServe + contenido.url_comprimido" target="_blank">
                                <i class="fas fa-file-archive icono-archivo icon-rar"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
          <span v-html="DateFormatText(fecha_actualizacion2)"></span>
        </div>
        <!-- <pre>{{ selected }}</pre> -->
      </div>
    </div>
  </div>
</template>
<script>
import mapFun from '@/common/map-fn-types.js';
import ArmonizacionContable from "@/services/ArmonizacionContable/ArmonizacionContable.service.js";
const _serviciosArmonizacionContable = new ArmonizacionContable();
import botonAtras from './../button-atras'
import { mapState } from "vuex";
import('@/assets/css/tab.css');
import tablaSimple from '@/components/tablaSimple.vue';
import PxSelect2 from '@/views/PxSelect.vue'
import searchVue from '@/components/search.vue';
import DateFormat from "@/mixins/dateFormatMixin.js";

export default {
    name: 'ResultadoEvaluaciones',
    components: { botonAtras, tablaSimple, PxSelect2, searchVue },
    mixins: [DateFormat],
    computed:{ ...mapState(['modoDark_var']) },
    data() {
        return {
          resultadosEvaluacionesACList:{
              "id": 1,
              "fecha_actualizacion": '',
              "seccion": []
            },
          fecha_actualizacion: '',
          fecha_actualizacion2: '',

          resultadosEvaluacionesList: [],

          itemActive1: true,
          itemActive2: false,
          itemActive3: false,

          textoTitulo: '',
          selected: '',
          datosRespuesta: []
        };
    },
    async created() {
        await this.getResultadoEvaluacionesArmonizacionCont();
        await this.getResultadosEvaluaciones();
    },
    methods: {
        async getResultadoEvaluacionesArmonizacionCont() {
            try {
              const response = await _serviciosArmonizacionContable.getResultadoEvaluacionesArmonizacionCont(mapFun.resultadosEvaluacionesArmonizacionCont);
             let data = response.data.reverse();
             this.fecha_actualizacion = data[0].fecha_actualizacion;
             this.resultadosEvaluacionesACList.seccion = data[0].contenido;

            } catch (error) {
                console.log('error', error.message);
            }
        },
        async getResultadosEvaluaciones() {
            try {
                const response = await _serviciosArmonizacionContable.getResultadoEvaluaciones(mapFun.resultadosEvaluaciones);
                let data = response.data;
                this.fecha_actualizacion2 = data[0].fecha_actualizacion;
                this.resultadosEvaluacionesList = data[0].contenido.reverse();
                this.resultadosEvaluacionesList = this.resultadosEvaluacionesList.map(function (e) {
                return {
                    id:       e.id,
                    text:     e.titulo,
                    seccion:  e.contenido
                };
              });

            } catch (error) {
                console.log('error', error.message);
            }
        }
    }
}
</script>
<style scoped>
.strong{ font-weight: 600;}
</style>
